module.exports = __webpack_public_path__ + "img/site_pcs.a5bb1a5e.jpg";